import { NSARouterMakerResult, NSAHomePage } from "namirasoft-account-react";
import { FieldLayout } from "../FieldLayout";
import { FieldProps } from "../FieldProps";

interface HomePageProps extends NSARouterMakerResult, FieldProps { }

export default function HomePage(props: HomePageProps)
{
    return (
        <FieldLayout {...props}>
            <NSAHomePage {...props} />
        </FieldLayout>
    );
}